document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector(".custom-signup__form");
  const submitButton = form.querySelector(".btn.submit-signup");
  const marketingCheckbox = document.querySelector("#contact-marketing-opt-in");
  const marketingError = document.querySelector("#marketing-error");
  const emailInput = document.querySelector("#contact-email");
  const firstNameInput = document.querySelector("#contact-first-name");

  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  if (email) {
    if (emailInput) {
      emailInput.value = email;
    }
  }

  submitButton.addEventListener("click", function (event) {
    if (!marketingCheckbox.checked) {
      event.preventDefault();
      if (marketingError) {
        marketingError.style.display = "block";
      }
      marketingCheckbox.focus();
      return;
    } else {
      const listId = "We3SHQ";
      const apiKey = "WBZEn6";

      const options = {
        method: "POST",
        headers: {
          revision: "2024-07-15",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: emailInput.value,
                    first_name: firstNameInput.value,
                  },
                },
              },
            },
            relationships: { list: { data: { type: "list", id: listId } } },
          },
        }),
      };

      fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${apiKey}`,
        options
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
        })
        .then((data) => {
          console.log(data);
          setTimeout(() => {
            window.location.href = "https://www.smokeandvape.ca/pages/thank-you-for-signing-up-to-our-newsletter";
          }, 500);
        })
        .catch((err) => console.error(err));
    }
  });
});
